import auth from "./AuthStore";
import workflow from "./WorkflowStore";

const stores = {
  auth,
  workflow
};

export default stores;
